<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">View Organization</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading"><strong>Organization Details</strong> </span>
          <span class="reviewstatus-{{org.status}}">{{org.status.toUpperCase()}}</span>
        </div>
        <div class="mb-10"></div>
        <div class="review-form-fileds">
          <span class="label" >Organization Name</span>
          <span class="answers">{{org.organizationName}}</span>
        </div>

        <div class="review-form-fileds">
          <span class="label">Province</span>
          <span class="answers">{{org.province}}</span>
          <span></span>
        </div>
        <div class="h-30"></div>
        <span><strong>Organization Members</strong></span>
        <div class="mb-10"></div>
        <div class="tableContents">
          <ng-container #container *ngTemplateOutlet="table; context: {data: org.organizationMembers, headerVisible: true}"></ng-container>
        </div>
        <ng-template #table let-data="data" let-headerVisible="headerVisible">
          <app-no-results #noResults></app-no-results>

          <table mat-table class="fileList primary" [dataSource]="data">
            <ng-container matColumnDef="membername">
              <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">Name</th>
              <td mat-cell *matCellDef="let orgs">
                {{orgs.orgUserName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Role">Role</th>
              <td mat-cell *matCellDef="let orgs">
                <ul class="stacked-list">
                  @for (role of orgs.orgUserRole; track role) {
                    <li>
                      {{ role }}
                    </li>
                  }
                </ul>
              </td>
            </ng-container>
            @if (headerVisible) {
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
            }
            <tr mat-row *matRowDef="let tags; columns: columnsToDisplay"></tr>
          </table>
        </ng-template>


        <div class="mb-10"></div>


        <div class="form-buttons">
          <button class="submit-form-button" (click)="navigate()">Edit</button>
          <button class="delete-button" (click)="deleteMaterial()">Delete</button>
        </div>

      </div>
    </form>
    <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
  </div>

</div>
@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}
<app-footer></app-footer>
